import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonos" className="defer-paint w-full scroll-mt-6 bg-zinc-900 py-12 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-5xl px-6" data-id="element-14" data-mp="qta0e4or5ral">
        <SectionHeading eyebrow="Inclusi gratis" title={<span id="bonuses-heading" data-id="element-16" data-mp="14sj2y1k1cmw3">+ 5 bonus esclusivi</span>} lead="Strumenti tattici per risolvere situazioni reali in pista." data-id="element-15" data-mp="qsi1okzuzdg3" />

        {/* Dos por renglón y una sola línea de beneficio por bono: la sección
            se mantiene corta y el peso visual queda en las portadas. */}
        <ul className="mt-9 grid grid-cols-2 gap-3 sm:gap-4" data-id="element-17" data-mp="19lc98tv5k3aa">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col gap-3 rounded-2xl border border-zinc-800 bg-zinc-950 p-3.5 sm:flex-row sm:items-center sm:gap-5 sm:p-5" data-id="element-18" data-mp="1nl3sb90j09v5">
              <img src={bonus.image} alt={bonus.alt} className="h-auto w-16 shrink-0 self-start rounded-lg object-cover sm:w-24 sm:self-center sm:rounded-xl" width={1024} height={1024} sizes="96px" loading="lazy" decoding="async" {...{
            fetchpriority: 'low'
          }} data-id="element-19" data-mp="3prwlcund43vt" />

              <div className="min-w-0 flex-1" data-id="element-20" data-mp="chpi11sfptlp">
                <div className="flex items-center gap-2.5" data-id="element-21" data-mp="gklt87fnanfm">
                  <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-stone-400" data-id="element-22" data-mp="gj0z2ix8t6ia">
                    Bonus {bonus.number}
                  </p>
                  <span className="shrink-0 rounded-full bg-yellow-500 px-2 py-0.5 font-sans text-[9px] font-bold uppercase tracking-[0.14em] text-zinc-950" data-id="element-23" data-mp="qaf3n541wwia">
                    Gratis
                  </span>
                </div>

                <h3 className="mt-2 font-serif text-lg font-bold leading-snug text-stone-100 sm:text-xl" data-id="element-24" data-mp="al8nezksfzeu">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.8rem] leading-relaxed text-stone-400" data-id="element-25" data-mp="5np9k0s05onf">
                  {bonus.tagline}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}